import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["searchInput", "domainItem", "emptyState"]

  filter() {
    const query = this.searchInputTarget.value.toLowerCase().trim()
    let visibleCount = 0

    this.domainItemTargets.forEach(item => {
      const url = (item.dataset.domainUrl || "").toLowerCase()
      const brand = (item.dataset.domainBrand || "").toLowerCase()
      const name = (item.dataset.domainName || "").toLowerCase()
      const matches = url.includes(query) || brand.includes(query) || name.includes(query)
      
      if (matches) {
        item.classList.remove("hidden")
        visibleCount++
      } else {
        item.classList.add("hidden")
      }
    })

    this.toggleEmptyState(visibleCount === 0)
  }

  clear() {
    this.searchInputTarget.value = ""
    this.filter()
    this.searchInputTarget.focus()
  }

  toggleEmptyState(show) {
    if (this.hasEmptyStateTarget) {
      if (show) {
        this.emptyStateTarget.classList.remove("hidden")
      } else {
        this.emptyStateTarget.classList.add("hidden")
      }
    }
  }
}
